<template>
  <div class="form-row">
    <ValidationProvider
      v-if="rules"
      :name="name"
      :rules="rules"
      tag="div"
      v-slot="{ errors }"
      :mode="mode"
      :vid="forId"
      ref="provider"
    >
      <div :class="{ invalid: errors.length > 0 }">
        <label
          class="form-label"
          :class="{ invalid: errors.length > 0 }"
          :for="forId"
        >
          {{ label }}
          <small
            class="form-legend"
            :class="{ invalid: errors.length > 0, block: legendBlock }"
            v-if="legend"
            >{{ legend }}</small
          >

          <p
            class="form-description"
            :class="{ invalid: errors.length > 0 }"
            v-if="description"
          >
            {{ description }}
          </p>
        </label>

        <slot></slot>

        <ul class="form-row-errors" v-if="errors.length">
          <li v-for="error of errors" :key="error">
            {{ error }}
          </li>
        </ul>
      </div>
    </ValidationProvider>

    <template v-else>
      <label class="form-label" :for="forId">
        {{ label }}
        <small class="legend" v-if="legend">{{ legend }}</small>

        <p class="form-description legend" v-if="description">
          {{ description }}
        </p>
      </label>
      <slot></slot>
    </template>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate'

export default {
  name: 'FormRow',

  components: {
    ValidationProvider,
  },

  props: {
    label: {
      type: String,
      default: '',
    },

    legend: {
      type: String,
      default: '',
    },

    description: {
      type: String,
      default: '',
    },

    forId: {
      type: String,
      default: '',
    },

    name: {
      type: String,
      default: '',
    },

    rules: {
      type: [String, Object],
      default: '',
    },

    mode: {
      type: String,
      default: 'aggressive',
    },

    legendBlock: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    if (this.$refs.provider) {
      this.unwatchValid = this.$watch(
        '$refs.provider.flags.valid',
        valid => {
          this.$emit('valid', valid)
        },
        {
          immediate: true,
        },
      )
    }
  },
}
</script>
